import { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "./styles.css";
import "react-tabs/style/react-tabs.css";
import { useEffect } from "react";
import api from "../../services/api";

export default function Clientes({termoPesquisa}) {
  
  const [clientes, setClientes] = useState([]);

  useEffect(() => {
    const buscarClientes = async () => {
      try {
        const response = await api.get("/api/buscarClientes");
        setClientes(response.data);
      } catch (error) {
        console.error("Erro ao buscar clientes:", error);
      }
    };

    buscarClientes();
    
  }, []);


  const clientesFiltrados = clientes?.filter((clientes) => {
    return clientes.nome_clientes.toLowerCase().includes(termoPesquisa.toLowerCase()) || clientes.nome_clientes.toLowerCase().includes(termoPesquisa.toLowerCase());
  });


  const customRowStyle = {
    "&:last-child td": {
      borderBottom: "none",
    },
  };

  
  const columns = [
    {
      field: "name",
      header: () => (
        <div className="flex flex-wrap align-items-center justify-content-between gap-2 ">
          <span className="text-xl text-900 ">Clientes</span>
          <div
              style={{ marginLeft: "750px", marginTop: "-20px", display: "flex",  borderWidth: "0px 0px 5px", fontFamily:"Satoshi" }}
          >
            
    
          </div>
        </div>
      ),
      body: (clientes) => (
        <div className="flex flex-wrap align-items-center justify-content-between gap-2">
          <span className="text-xl">{clientes.nome_clientes}</span>
          <div
            style={{ marginLeft: "500px", marginTop: "-20px", display: "flex", fontFamily:"Satoshi" }}
          >
            
          </div>
        </div>
      ),
    },
  ];

  return (
    <div
      className="w-full"
    >

      <DataTable
        value={clientesFiltrados}
        stripedRows
        style={{
          height: "500px",
          fontWeight: "400",
          color:"#000!important",        
          borderWidth: "1px 1px 0px 1px"
        }}
        scrollable
        paginator
        rows={10}
        rowsPerPageOptions={[10, 25, 50]}
        tableStyle={{ minWidth: "50rem" }}
        
        
      >
        {columns.map((col, i) => (
          <Column
            key={col.field}
            field={col.field}
            header={col.header}
            body={col.body}
            rowStyle={customRowStyle}
          />
        ))}
      </DataTable>
    </div>
  );
}